import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * There is one home route, and it works out for itself who is reading it.
 *
 * This route stays as a redirect because it is baked into sign in return addresses, older app
 * builds and notification links, none of which can be changed after the fact.
 */
export const Route = createFileRoute('/home')({
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true });
  },
});
